<template>
  <el-upload
    v-loading="loading"
    class="uploader"
    :with-credentials="true"
    :show-file-list="false"
    :http-request="uploadRequest"
    name="image"
    accept=".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp"
    :before-upload="beforeUpload"
  >
    <img v-if="value" :src="value" class="upload-image" @load="finishLoad" @error="finishLoad" />
    <i class="el-icon-plus uploader-icon" :class="{ show: !value }" />
  </el-upload>
</template>

<script>
import {
  compressUploadImage,
  isAllowedUploadImageType,
  UPLOAD_IMAGE_MAX_BYTES,
} from "@/utils/imageCompression";
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    beforeUpload(file) {
      if (!isAllowedUploadImageType(file.type)) {
        this.$message.error("仅支持 JPG、PNG、WEBP 图片");
        return false;
      }
      this.loading = true;
      return true;
    },
    async uploadRequest(options) {
      try {
        const uploadFile = await compressUploadImage(options.file);
        if (uploadFile.size > UPLOAD_IMAGE_MAX_BYTES) {
          this.$message.error("图片压缩后仍然过大，请换一张更小的图片");
          this.loading = false;
          return;
        }

        const formData = new FormData();
        formData.append("image", uploadFile, uploadFile.name);
        const data = await this.axios.post("/api/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        this.$emit("input", data.url);
        this.$message.success("上传成功");
      } catch (error) {
        this.loading = false;
      }
    },
    finishLoad() {
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.uploader {
  width: 178px;
  height: 178px;
  border: 2px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  &:hover {
    border-color: #409eff;

    .uploader-icon {
      display: block;
    }
  }

  .uploader-icon {
    font-size: 36px;
    font-weight: 700;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
    position: absolute;
    top: 0;
    left: 0;
    display: none;

    &:hover {
      color: #409eff;
    }
    &.show {
      display: block;
    }
  }
  .upload-image {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>
